<template>
  <div class="comparison-table-wrapper row py-xxl">
    <div class="col-12 offset-md-2 col-md-8">
      <SectionHeadline
        title="Armoire vs. Other clothing rental subscriptions"
        class="mb-md"/>
      <div class="table-wrapper pt-lgp pt-md-xxl border-top-armor pb-xl">
        <table class="w-100">
          <thead class="pb-lgp">
            <tr>
              <th>
                <component
                  :is="isMobile ? 'h5' : 'h3'">
                  Features
                </component>
              </th>
              <th>
                <component
                  :is="isMobile ? 'h5' : 'h3'"
                  class="mx-auto">
                  Armoire
                </component>
              </th>
              <th>
                <component
                  :is="isMobile ? 'h5' : 'h3'"
                  class="mx-auto">
                  Rent the Runway
                </component>
              </th>
              <th>
                <component
                  :is="isMobile ? 'h5' : 'h3'"
                  class="mx-auto">
                  Nuuly
                </component>
              </th>
            </tr>
          </thead>
          <tbody class="comparison-body">
            <tr
              v-for="attribute in attributes"
              :key="attribute.id">
              <td>
                <p :class="{'small-feature': isMobile}">
                  {{ attribute.text }}
                </p>
              </td>
              <td class="svg">
                <svg-check
                  v-if="attribute.armoire"
                  :height="isMobile ? 24 : 32"
                  :width="isMobile ? 24 : 32"
                  :stroke-width="2.5"
                  variant="success"/>
              </td>
              <td class="svg">
                <svg-check
                  v-if="attribute.rtr"
                  :height="isMobile ? 24 : 32"
                  :width="isMobile ? 24 : 32"
                  :stroke-width="2.5"
                  variant="success"/>
                <svg-x
                  v-else
                  :height="isMobile ? 24 : 32"
                  :width="isMobile ? 24 : 32"/>
              </td>
              <td class="svg">
                <svg-check
                  v-if="attribute.nuuly"
                  :height="isMobile ? 24 : 32"
                  :width="isMobile ? 24 : 32"
                  :stroke-width="2.5"
                  variant="success"/>
                <svg-x
                  v-else
                  :height="isMobile ? 24 : 32"
                  :width="isMobile ? 24 : 32"/>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="d-flex flex-column align-items-center gap-lg mt-lgp mb-xl">
        <p class="text-center m-md">
          Take your Style Quiz today and experience the best of clothing rental
        </p>
        <GetStartedButton
          location="Comparison"
          class="fixed-width"/>
      </div>
    </div>
  </div>
</template>

<script setup>
import SvgCheck from '@/homepage/components/svg/SvgCheck.vue'
import SvgX from '@/homepage/components/svg/SvgX.vue'
import GetStartedButton from '@/homepage/components/GetStartedButton.vue'
import useScreenSize from '@shared/composables/screenSize'
import SectionHeadline from '@/components/global/SectionHeadline.vue'

const { isMobile } = useScreenSize()
const attributes = [
  {
    id: 'curated',
    text: 'Curated closet via recommendation algorithm and personal stylists',
    armoire: true,
    rtr: false,
    nuuly: false
  },
  {
    id: 'flexible',
    text: 'Flexible plans for every budget, including an Unlimited plan',
    armoire: true,
    rtr: false,
    nuuly: false
  },
  {
    id: 'high-end',
    text: 'High-end brands you love',
    armoire: true,
    rtr: true,
    nuuly: true
  },
  {
    id: 'women',
    text: 'Rising women- and POC-owned brands you should know about',
    armoire: true,
    rtr: false,
    nuuly: false
  },
  {
    id: 'returns',
    text: 'Flexible returns — keep your old items until new items arrive',
    armoire: true,
    rtr: false,
    nuuly: false
  }
]
</script>

<style lang="scss" scoped>
.comparison-table-wrapper {
  max-width: 1440px;
  margin: 0 auto;
}
.comparison-body {
  tr:nth-child(even) {background: $white}
  tr:nth-child(odd) {background: $origami}

  td {
    max-width: 415px;
    vertical-align: middle;
    padding: 16px 9px;
    width: fit-content;
    @include medium {
      padding: 16px 20px;
    }

  }
}
th {
  h3 {
      max-width: 128px;
      text-align: center;
  }
  :first-child {
    padding-bottom: $spacing-lg;

    @include media-mobile {
      max-width: 120px;
      padding: $spacing-sm $spacing-xxs;
      margin: 0;
    }
  }
}
.svg {
  text-align: center;
}

.small-feature {
  font-size: 14px !important;
}
</style>
